const rotateIcon = (dir) => ({
  fullRotate: dir === 'ltr' ? 'rotate(180deg)' : 'none'
});
export default rotateIcon;
